var arrInvalidEmails = new Array();
var arrValidEmails = new Array();

jQuery(document).ready(function() {
	jQuery.validator.addMethod("email-check", function(value, element) {
		var err = false;
		if (jQuery.inArray(value, arrValidEmails) != -1) {
		} else if (jQuery.inArray(value, arrInvalidEmails) != -1) {
			err = true;
		} else {
			jQuery.ajax({
				cache: false,
				async: false,
				type: "post",
				data: "email=" + encodeURIComponent(value),
				url: "/includes/check_email.php",
				success: function(msg) {
					if (msg == "false") {
						err = true;
						arrInvalidEmails.push(value);
					} else {
						arrValidEmails.push(value);
					}
				}
			});
		}
		return this.optional(element) || !err;
	});

    jQuery.validator.addMethod("password-check", function(value, element) {
        var err = false;
        jQuery.ajax({
            cache: false,
            async: false,
            type: "post",
            data: "password=" + encodeURIComponent(value),
            url: "/includes/check_password.php",
            success: function(msg) {
                if (msg == "false") {
                    err = true;
                }
            }
        });
        return this.optional(element) || !err;
    });

    jQuery.validator.addMethod("password-repeat", function(value, element) {
        var err = false;
        if (value != jQuery('#password').val()) {
            err= true;
        }
        return this.optional(element) || !err;
    });
});
